import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";

const QuestionSection = ({ question, answer }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleExpansion = () => {
    setIsExpanded((prev) => !prev);
  };

  useEffect(() => {
    if (question === "What are your COVID-19 protocols?") {
      setIsExpanded(true);
    }
  }, []);

  return (
    <div
      className={`py-4 border-b-[1px] border-[#D9DBE9] ${isExpanded ? "" : ""}`}
    >
      <div className="flex items-start justify-between text-[#183864] gap-4">
        <div
          className={`font-[500] text-[14px] sm:text-[16px] lg:text-[22px] leading-[18px] sm:leading-[22px] lg:leading-[28px] ${isExpanded ? "text-[#170F49]" : "text-[#183864]"} flex-1 pr-2`}
        >
          {question}
        </div>
        <div
          className="cursor-pointer flex-shrink-0 mt-1"
          onClick={toggleExpansion}
        >
          {isExpanded ? (
            <svg
              width="17"
              height="3"
              viewBox="0 0 17 3"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1.46289 1.95483H15.4629"
                stroke="#183864"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          ) : (
            <svg
              className="hover:rotate-90 duration-300"
              width="17"
              height="17"
              viewBox="0 0 17 17"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M8.46289 1.95483V15.9548"
                stroke="#170F49"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M1.46289 8.95483H15.4629"
                stroke="#170F49"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          )}
        </div>
      </div>
      {isExpanded && (
        <div className="font-[400] text-[12px] sm:text-[14px] lg:text-[18px] leading-[16px] sm:leading-[18px] lg:leading-[30px] text-[#6F6C90] py-2 lg:py-4 overflow-hidden">
          {answer}
          <span className="font-[500] text-[#183864] ml-1 break-all">
            https://www.prosafetraining.ca/communicable-disease-plan/
          </span>
        </div>
      )}
    </div>
  );
};

const FrequentlyAskQuestion = ({ faqData, source }) => {
  const [selectedTab, setSelectedTab] = useState("General");

  return (
    <div className="w-full">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="shadow-md py-6 lg:py-10 px-4 lg:px-10 xl:px-16 rounded-[18px] mb-10 mx-4 lg:mx-0"
        style={{ boxShadow: "0 -2px 10px 0 rgba(0, 0, 0, 0.2)" }}
      >
        {/* Categories Section */}
        <div className="flex justify-center lg:justify-start gap-2 lg:gap-4 mb-8">
          <div
            className="h-[34.58px] lg:h-[68px] flex-1 max-w-[120px] lg:max-w-[168px]"
            onClick={() => setSelectedTab("General")}
          >
            <motion.div
              whileHover={{ scale: 1.05, y: -2 }}
              whileTap={{ scale: 0.95 }}
              animate={
                selectedTab === "General" ? { scale: 1.02 } : { scale: 1 }
              }
              transition={{ duration: 0.2 }}
              className={`flex items-center justify-center h-full ${selectedTab === "General" ? "bg-[#B02526] text-white shadow-lg" : "text-[#6F6C90] hover:bg-gray-50"} rounded-[7.12px] lg:rounded-[14px] border-[1px] border-[#D9DBE9] cursor-pointer text-[10.17px] lg:text-[18px] font-[500] leading-[28px] transition-all duration-300`}
            >
              General
            </motion.div>
          </div>
          <div
            className="h-[34.58px] lg:h-[68px] flex-1 max-w-[120px] lg:max-w-[168px]"
            onClick={() => setSelectedTab("First Aid")}
          >
            <motion.div
              whileHover={{ scale: 1.05, y: -2 }}
              whileTap={{ scale: 0.95 }}
              animate={
                selectedTab === "First Aid" ? { scale: 1.02 } : { scale: 1 }
              }
              transition={{ duration: 0.2 }}
              className={`flex items-center justify-center h-full ${selectedTab === "First Aid" ? "bg-[#B02526] text-white shadow-lg" : "text-[#6F6C90] hover:bg-gray-50"} rounded-[7.12px] lg:rounded-[14px] border-[1px] border-[#D9DBE9] cursor-pointer text-[10.17px] lg:text-[18px] font-[500] leading-[28px] transition-all duration-300`}
            >
              First Aid
            </motion.div>
          </div>
          <div
            className="h-[34.58px] lg:h-[68px] flex-1 max-w-[120px] lg:max-w-[168px]"
            onClick={() => setSelectedTab("Campus")}
          >
            <motion.div
              whileHover={{ scale: 1.05, y: -2 }}
              whileTap={{ scale: 0.95 }}
              animate={
                selectedTab === "Campus" ? { scale: 1.02 } : { scale: 1 }
              }
              transition={{ duration: 0.2 }}
              className={`flex items-center justify-center h-full ${selectedTab === "Campus" ? "bg-[#B02526] text-white shadow-lg" : "text-[#6F6C90] hover:bg-gray-50"} rounded-[7.12px] lg:rounded-[14px] border-[1px] border-[#D9DBE9] cursor-pointer text-[10.17px] lg:text-[18px] font-[500] leading-[28px] transition-all duration-300`}
            >
              Campus
            </motion.div>
          </div>
        </div>

        {/* Questions Container */}
        <div className="border-b-[1px] border-[#D9DBE9] w-full">
          {faqData?.map(
            (item, index) =>
              item.category === selectedTab && (
                <QuestionSection
                  key={index}
                  question={item.faq.question}
                  answer={item.faq.answer}
                />
              ),
          )}
        </div>
      </motion.div>
    </div>
  );
};

export default FrequentlyAskQuestion;
